const Header = () => {
    return (
      <div className="header">
        <h2>TODO APP</h2>
      </div>
    )
  }
  
  export default Header;
  